import React, { useState, useEffect } from "react";
import Calendar from "react-calendar";
import { dateFormat, dateFormatAccToTimeZone, timeStamp } from "../../../services/Util";
import { useDispatch, useSelector } from 'react-redux'
import { tasksSameDate } from "../../../redux/reducers/TasksOnSameDateSlice";
import "react-calendar/dist/Calendar.css";
import $ from "jquery";
export default function TaskListCalendar(props) {
  const [taskOnSelectedDate, setDateTask] = useState([]);
  const [taskDate, setTaskDate] = useState('');
  const [taskType,setTaskType] = useState('');
  const [taskTypeLabel,setTaskTypeLabel] = useState('');
  const dispatch = useDispatch();
  const itemDates = new Array();
  const custBootstrapDataRedux = useSelector(
    (store) => store.customer_bootstrap_data
  ).value;

  const tasks = props.tasks;
  props.tasks.map((task) => {
    itemDates.push(custBootstrapDataRedux?.user?.timeZone !==undefined? dateFormatAccToTimeZone(task.createdDate,"D-M-YYYY",custBootstrapDataRedux?.user?.timeZone):dateFormat(task.createdDate,"D-M-YYYY"));
  });
  const count = {};
  const showRightModel = () => {
    document.body.classList.add("modal-open");
    $(".right-modal").removeClass("nodisplay")
    $(".terms-and-condition-model").addClass("nodisplay")
    setTimeout(() => {
      $('.close').trigger('focus');
    }, 200);
  };
  for (const element of itemDates) {
    if (count[element]) {
      count[element] += 1;
    } else {
      count[element] = 1;
    }
  }
  const popup = (event) => {
  };
  const selectedTask = useSelector(
    (TaskTypeSelected) => TaskTypeSelected.task_selected
  ).value;
const setAriaLabel = () =>{
  setTimeout(() => {
    $.each($('.react-calendar__tile'), function( index, value ) {
      let textValue = '';
      if($(value.children[1]).length) {
        textValue = $(value.children[1]).text();
      }
      $(value).attr('aria-label', value?.children[0]?.ariaLabel+' '+(textValue?textValue:"0 Task"));
    });
  }, 500);
  
}
useEffect(()=>{
  setAriaLabel();
  // $('.react-calendar__tile react-calendar__month-view__days__day').attr('aria-label', 'main navigation');
  dispatch(tasksSameDate([taskOnSelectedDate,taskDate,taskTypeLabel]));
},[taskOnSelectedDate]);
  return (
    <Calendar
      calendarType={props.calendarType}
      locale={props.locale}
      selectRange={props.selectRange}
      className={props.className}
      prevAriaLabel="previous month"
      nextAriaLabel="next month"
      
      prev2AriaLabel="previous year"
      next2AriaLabel="next year"
      showNeighboringMonth={false}
      showDoubleView={false}
      tileClassName={({ date, view }) => {
        if (count[dateFormat(date,"D-M-YYYY")] !== undefined) {
          return "taskDate";
        }
      }}
      
      onActiveStartDateChange = {
        ({ action, activeStartDate, value, view }) => setAriaLabel()
      }
      onClickDay={(date, view) =>
        // eslint-disable-next-line array-callback-return
        {
          if ($(document.activeElement).hasClass('taskDate')) {
            $(document.activeElement).closest('button').attr('id');
          }
          setDateTask([]);
          tasks.map((task)=>{
            let taskDates = dateFormat(date,"D-M-YYYY")
            let selectedDate =custBootstrapDataRedux?.user?.timeZone !==undefined? dateFormatAccToTimeZone(task.createdDate,"D-M-YYYY",custBootstrapDataRedux?.user?.timeZone):dateFormat(task.createdDate,"D-M-YYYY");
            if(taskDates === selectedDate){
              setDateTask(current => [...current, task]);
              setTaskDate(timeStamp(date, custBootstrapDataRedux?.user?.timeZone).utcTimestamp);
              setTaskType(selectedTask[0]);
              setTaskTypeLabel(selectedTask[1])
              showRightModel();
            }
          })
        }
      }
      //showDoubleView={props.showDoubleView}
      tileContent={({ date, view }) =>
        // eslint-disable-next-line array-callback-return
        // eslint-disable-next-line no-useless-concat
        {
          if (count[dateFormat(date,"D-M-YYYY")] !== undefined) {
            return (
              <div className="taskDate">
                <span
                // onClick={(e) =>popup(e)}
                >
                  {count.length}
                  {count[dateFormat(date,"D-M-YYYY")] > 1   ? count[dateFormat(date,"D-M-YYYY")]+' tasks': count[dateFormat(date,"D-M-YYYY")]+' task'}
                </span>
              </div>
            );
          }
        }
      }

      //   }
    />
  );
}
